var _line, _path, _ellipse, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFoundicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 180,
    viewBox: "0 0 132 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 67.2723,
    y1: 69.3774,
    x2: 67.2723,
    y2: 0.991905,
    stroke: "url(#paint0_linear_1724_8566)",
    strokeWidth: 0.636145
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9524 75.7391C73.9524 74.052 73.2822 72.4339 72.0892 71.2409C70.8962 70.0479 69.2781 69.3777 67.5909 69.3777C65.9038 69.3777 64.2857 70.0479 63.0927 71.2409C61.8997 72.4339 61.2295 74.052 61.2295 75.7391L67.5909 75.7391H73.9524Z",
    fill: "url(#paint1_linear_1724_8566)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0361,
    cy: 4.77108,
    rx: 27.0361,
    ry: 4.77108,
    transform: "matrix(-1 0 0 1 94.626 96.4141)",
    fill: "url(#paint2_linear_1724_8566)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.5542 100.999H94.6265L132 179.999H0L40.5542 100.999Z",
    fill: "url(#paint3_linear_1724_8566)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.626 101.185C94.626 94.0146 91.7776 87.1379 86.7073 82.0676C81.637 76.9974 74.7603 74.1489 67.5899 74.1489C60.4194 74.1489 53.5427 76.9974 48.4724 82.0676C43.4022 87.1379 40.5537 94.0146 40.5537 101.185L67.5899 101.185H94.626Z",
    fill: "url(#paint4_linear_1724_8566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1724_8566",
    x1: 67.5903,
    y1: 35.1847,
    x2: 68.5903,
    y2: 35.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402C5E",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8865BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1724_8566",
    x1: 62.1274,
    y1: 72.3917,
    x2: 73.8724,
    y2: 72.2612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1724_8566",
    x1: 3.81627,
    y1: 2.26053,
    x2: 53.5413,
    y2: -0.870306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1724_8566",
    x1: 66,
    y1: 100.999,
    x2: 66,
    y2: 179.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#975EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246075,
    stopColor: "#38117D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2268",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1724_8566",
    x1: 44.37,
    y1: 86.9586,
    x2: 94.286,
    y2: 86.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115733,
    stopColor: "#8D42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222473,
    stopColor: "#AB86E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34481,
    stopColor: "#9E7ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555237,
    stopColor: "#6C44A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290A58"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundicon);
export default __webpack_public_path__ + "static/media/notFoundicon.57b06c1578ba988081e571527cf057c5.svg";
export { ForwardRef as ReactComponent };